import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "createFolderDialogContent" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  class: "kn-material-input-label",
  for: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary createFolderDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('managers.resourceManagement.createFolder'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.folderName && _ctx.folderName.length == 0,
        onClick: _ctx.emitCreateFolder
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Breadcrumb, {
        home: _ctx.home,
        model: _ctx.items
      }, null, 8, ["home", "model"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InputText, {
            class: "folderNameInputText",
            type: "text",
            modelValue: _ctx.folderName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.folderName = $event))
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.resourceManagement.foldernamePlaceholder')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}